<template>
  <div class="sample-detail-primary-results">
    <h3>Results</h3>
    <div class="input-row">
      <SampleLabelControl :showAverageResults="showAverageResults" />
      <SampleLabelControl :showAverageResults="showAverageResults" />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Cu"
        propName="copperDisplay"
        propAverageName="averageCopper"
        propSeverityName="copperSeverityID"
        :tabindex="100"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Fe"
        propName="ironDisplay"
        propAverageName="averageIron"
        propSeverityName="ironSeverityID"
        :tabindex="102"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Si"
        propName="siliconDisplay"
        propAverageName="averageSilicon"
        propSeverityName="siliconSeverityID"
        :tabindex="104"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Al"
        propName="aluminumDisplay"
        propAverageName="averageAluminum"
        propSeverityName="aluminumSeverityID"
        :tabindex="106"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Zn"
        propName="zincDisplay"
        propAverageName="averageZinc"
        propSeverityName="zincSeverityID"
        :tabindex="108"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Pb"
        propName="leadDisplay"
        propAverageName="averageLead"
        propSeverityName="leadSeverityID"
        :tabindex="110"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Mo"
        propName="molybdenumDisplay"
        propAverageName="averageMolybdenum"
        propSeverityName="molybdenumSeverityID"
        :tabindex="112"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Mg"
        propName="magnesiumDisplay"
        propAverageName="averageMagnesium"
        propSeverityName="magnesiumSeverityID"
        :tabindex="114"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Ca"
        propName="calciumDisplay"
        propAverageName="averageCalcium"
        propSeverityName="calciumSeverityID"
        :tabindex="116"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="P"
        propName="phosphorusDisplay"
        propAverageName="averagePhosphorus"
        propSeverityName="phosphorusSeverityID"
        :tabindex="118"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Na"
        propName="sodiumDisplay"
        propAverageName="averageSodium"
        propSeverityName="sodiumSeverityID"
        :tabindex="120"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="B"
        propName="boronDisplay"
        propAverageName="averageBoron"
        propSeverityName="boronSeverityID"
        :tabindex="122"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Sn"
        propName="tinDisplay"
        propAverageName="averageTin"
        propSeverityName="tinSeverityID"
        :tabindex="124"
        :formData="sampleData"
        :showAverageResults="showAverageResults"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="K"
        propName="potassiumDisplay"
        propAverageName="averagePotassium"
        propSeverityName="potassiumSeverityID"
        :tabindex="126"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <br />
    </div>
  </div>
</template>
<script>
import SampleDetailParticleControl from './CoolantSampleResultParticleControl.vue';
import SampleLabelControl from '../../shared/SampleLabelControl.vue';
export default {
  name: 'SampleDetailPrimaryResults',
  props: {
    sampleData: {
      type: Object,
      required: true
    },
    showAverageResults: {
      type: Boolean
    },
    mappings: {
      type: Object,
      required: true
    }
  },
  components: {
    SampleDetailParticleControl,
    SampleLabelControl
  }
};
</script>

<style lang="scss" scoped>
.sample-detail-primary-results {
  .input-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  h3,
  h5 {
    display: inline;
  }
}
</style>
